module.exports = __webpack_public_path__ + "img/dtlogo.0ae70849.png";